import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const setDealerActive = createAction(actionType.SET_DEALER_ACTIVE);
const resetDealerActive = createAction(actionType.RESET_DEALER_ACTIVE);
export { setDealerActive, resetDealerActive };
